import { PackageTypeEnum } from '../domain';
import { z } from 'zod';

export const CategoryItemResponse = z.object({
  id: z.string(),
  name: z.string(),
  hidden: z.boolean().optional(),
  type: z.nativeEnum(PackageTypeEnum).optional(),
});

export const CategoryListResponse = z.object({
  categories: z.array(CategoryItemResponse),
  type: z.nativeEnum(PackageTypeEnum).optional(),
});
